import { Directive, InjectionToken, TemplateRef } from '@angular/core';

export const SELECT_LABEL_CONTENT =
  new InjectionToken<SelectLabelContentDirective>('SelectLabelContent');

@Directive({
  selector: '[appSelectLabel]',
  providers: [
    { provide: SELECT_LABEL_CONTENT, useExisting: SelectLabelContentDirective },
  ],
  standalone: false,
})
export class SelectLabelContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
